import styles from './bottomCards.module.scss'
import GreenCard from '../Cards/GreenCard'
import BlueCard from '../Cards/BlueCard'
import { useTranslations } from '../../contexts/LanguageContext'

function BottomCards() {
    const t = useTranslations()
  return (
      <div className={styles.bottomSections}>
        <GreenCard>
          <h2>{t('shared_greenCard_title1', "This is personal")}</h2>
          <p>{t('shared_greenCard_paragraph1', "Some of the questions may feel personal or intrusive. Your answers are voluntary and you have the right to decline questions that make you feel uncomfortable.")}</p>
          <h3>{t('shared_greenCard_title2', "Need to talk?")}</h3>
          <p>{t('shared_greenCard_paragraph2', "If you need support during or after taking the survey, please call or text anytime 24/7:")}</p>
          <p><strong>1-844-493-TALK (8255)</strong></p>
          <p><strong>Text TALK to 38255</strong></p>
        </GreenCard>
        <BlueCard>
          <h2>{t('shared_blueCard_title1', "Have questions?")}</h2>
          <h3>{t('shared_blueCard_paragraph1', "For questions about this survey contact:")}</h3>
          <a href="mailto:CDHS_TRAILS_NYTD@state.co.us">CDHS_TRAILS_NYTD@state.co.us</a>
          <p><strong>303-585-0288</strong></p>
        </BlueCard>
      </div>
  )
}

export default BottomCards